import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import fetch from 'isomorphic-fetch'

import HubSpotForm from '../form/HubSpotForm'
import { guessVars } from '../../actions/states/new/setupVars'

const WebinarResponseForm = () => {
  const [pageTitle, setPageTitle] = useState('Latest Webinar')
  const [submitted, setSubmitted] = useState(false)
  const params = useParams()
  const variableArray = guessVars(params.state)
  const qsParam = variableArray?.siteId ? `?regionId=${variableArray.siteId}` : ''
  const { data } = useQuery(['latest-webinars', qsParam], () => {
    return fetch(`/api/v2/marketing/webinars${qsParam}`, {
      method: 'GET'
    }).then(resp => resp.json())
  })
  const markFormAsSubmitted = () => {
    setSubmitted(true)
  }
  const findParams = (state, response) => {
    switch (state) {
      default:
        return {
          willAttend: response !== 'no'
        }
    }
  }
  const vars = findParams(params.state, params.response)
  const upcoming = data?.upcoming

  return (
    <div>
      <div className="container">
        <div className="row">
          <h2 className="page-title">{pageTitle}</h2>
        </div>
      </div>
      <div
        className="title-block-bar"
        style={{ paddingTop: '75px', backgroundColor: '#1DA7E0' }}>
        <div className="container">
          <img
            src="/images/www/new/webinar/canmakeit.png"
            style={{
              maxWidth: '60%',
              marginLeft: '20px',
              zIndex: '100',
              position: 'relative'
            }}
            className="pull-right"
          />
          <p style={{ fontSize: '1.2rem', marginRight: '20px' }}>
            {upcoming?.webinarDetails}
          </p>
        </div>
      </div>

      <div className="container" style={{ marginTop: '25px', marginBottom: '25px' }}>
        {submitted ? null : (
          <ul
            className="nav nav-pills"
            style={{ display: 'flex', justifyContent: 'center' }}>
            <li className={vars.willAttend ? 'active' : ''}>
              <Link
                style={{ fontSize: '1.5em' }}
                to={`${variableArray.pathPrefix}/webinar/yes`}>
                I can make it
              </Link>
            </li>
            <li className={!vars.willAttend ? 'active' : ''}>
              <Link
                style={{ fontSize: '1.5em' }}
                to={`${variableArray.pathPrefix}/webinar/no`}>
                I can't make it
              </Link>
            </li>
          </ul>
        )}
        {submitted ? null : (
          <h3>
            {vars.willAttend
              ? "We're so glad you'll be able to attend! If you fill out the form below, we can send you a calendar invite and make sure that after the webinar, we'll send you the recording."
              : "We're sorry you won't be able to attend. However, if you fill out the form below, we'll make sure to send you a recording after the webinar."}
          </h3>
        )}
        <HubSpotForm
          formId={upcoming?.webinarSignupForm}
          onFormLoad={form => {
            if (form.name) {
              setPageTitle(form.name)
            }
          }}
          executeOnSubmit={markFormAsSubmitted}
        />
      </div>
      {!!variableArray.webinarHistory?.length > 0 && (
        <div
          className="title-block-bar section"
          style={{
            backgroundColor: '#eee',
            paddingTop: '65px',
            paddingBottom: '65px',
            marginTop: '25px'
          }}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <h3>Watch our Last Webinar</h3>
                <p style={{ color: 'black', fontSize: '1rem' }}>
                  Interested in our most recent webinar? You can{' '}
                  <Link to={`${variableArray.pathPrefix}/webinar/latest`}>
                    watch it here
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export { WebinarResponseForm }
